import { Coordinate } from 'ol/coordinate';

export class GeomHelpers {
    static radius3857ToMeters(center4326: Coordinate, radius3857: number): number {
        const latRad = (center4326[1] * Math.PI) / 180;
        return radius3857 * Math.cos(latRad);
    }

    static metersTo3857Radius(center4326: Coordinate, radiusMeters: number): number {
        const latRad: number = (center4326[1] * Math.PI) / 180;
        return radiusMeters / Math.cos(latRad);
    }
}
